module.exports = __webpack_public_path__ + "img/apple-icon-152x152.4a9695d6.png";